<template  >
<v-layout column full-width class="">
    <!-- grid-list-sm -->
    <v-layout v-if="!page_show">
        <not-page-spinner :not_show="true" /> 
    </v-layout>       
    <div v-else > 

        <!-- Services -->
        <div class="">
            <v-container grid-list-md class="">
                <v-layout column> 
                    <v-row>
                        <v-col sm="6" md="4"   cols="12" v-for="(study, index) in p_services.list" :key="index" class="px-1">
                            <v-card height="100%" :to="'/services/'+study.key"
                                class="mx-aut ma-1" 
                                hover="" shaped=""> 
                                <v-hover v-slot:default="{ hover }">
                                    <v-layout column="" fill-height="">
                                        <v-card shaped="" flat class="mx-1" v-if="!study.image">
                                            <v-img
                                                class="white--text align-end"
                                                aspect-ratio="1.8"
                                                :src="not.noImg"
                                                :lazy-src="not.imgLazy"
                                                > 
                                                <v-overlay color="primary" absolute="" z-index="1"></v-overlay>
                                            </v-img>
                                            <br> 
                                        </v-card>
                                        <v-card shaped="" title="" flat class="mx-1" v-else>
                                            <v-img
                                                class="white--text align-end"
                                                aspect-ratio="1.8"
                                                :src="study.image.link"
                                                :lazy-src="not.imgLazy"
                                                > 
                                            </v-img>
                                            <br> 
                                        </v-card>
                                        <!-- //OVERLAY BACKGROUND COLOR -->
                                        <v-overlay v-if="hover" color="primary" opacity="0.7" absolute="" z-index="1">
                                            <div class="not-f9">View</div>
                                        </v-overlay>
                                        <v-card-title class="mt-0 pt-0 mb-5 ">
                                            <div class="not-f7 font-weight-bol">
                                                <div v-if="not.size(study.name)<18">{{not.TEXT_UP(study.name)}}</div>
                                                <div v-else>{{not.TEXT_UP(study.name?study.name.substring(0,18):'')+"..."}}</div>
                                            </div> 
                                            
                                        </v-card-title> 
                                        <v-card-text>
                                            <div v-for="(line, index) in not.TEXT_SPLIT_N(study.desc)" :key="index">{{line}}</div>
                                        </v-card-text>
                                        
                                        <v-spacer></v-spacer>
                                        <!-- <v-card-actions>
                                            <v-spacer></v-spacer> 
                                            <v-btn color="primary" text>Read more</v-btn>

                                        </v-card-actions>  -->
                                         
                                    </v-layout>  
                                </v-hover>
                                </v-card>
                        </v-col> 
                    </v-row>
                </v-layout>
            </v-container> 
        </div>

        
        
        <!-- See the archive button -->
        <v-container grid-list-xs>
            <v-layout justify-center="" align-center="" class="py-4" >
                <v-hover v-slot:default="{hover}">
                    <v-card :color="hover?'b1':'primary'" width="100%"  to="/services"  flat=""  >
                        <v-layout justify-center="" align-center="">
                            <v-col sm="12" >
                                <v-layout align-center="" justify-center="">
                                    <div :class="hover?'primary flex':'b2  flex '" justify-center="">
                                        <div :class="hover?'text-center not-f7 font-weight-bold font-italic white--text py-3':'text-center not-f7 font-weight-bold font-italic primary--text py-3'">View all Services</div> 
                                    </div> 
                                    <div :class="hover?' triagleH':' triagle'"  ></div>
                                </v-layout>
                            </v-col> 
                        </v-layout>
                    </v-card>
                </v-hover>
            </v-layout> 
        </v-container>

        <v-layout class="b2 pb-5">
            <v-container grid-list-xs>
                <v-row class="text-center">  

                    <v-col sm="6">   
                        <div class="not-f8 font-weight-black py-5 primary--tex">
                            WHO WE ARE
                        </div>
                        <div class="not-f7 font-italic">
                            <v-layout justify-center> 
                                <div class="text-justify"> 
                                <v-icon>mdi-format-quote-open</v-icon>
                                    The Congegation of the Teresian sisters started in 1929 with Bishop Maturino Guilleme.It started with four girls who made their first profession in 1937.St Teresa is a patrone st of the Teresian sisters in Malawi and Zambia.
                                <v-icon>mdi-format-quote-close</v-icon>
                                </div>
                            </v-layout>  
                        </div> 
                    </v-col> 
                    <v-col class=" py-0 my-0" sm="6">
                        <v-layout fill-height="" align-center="" justify-center="">
                            <v-img src="logo/l1.png"    max-width="300" />  
                        </v-layout>
                    </v-col>
                </v-row> 
            <br> 
            <v-layout justify-center="">
                <v-btn to="/about" outlined="" color="primary">More About Us</v-btn>
            </v-layout>
            </v-container> 
        </v-layout>

        <template>
            <v-parallax 
            height="550"
                :src="require(`@/assets/awrim/three/t0.jpg`)"
                >
                <v-layout  justify-center=""  align-center="" column="" class="b1--text pb-5"> 
                    <v-col sm="8">
                        <v-row>
                            <v-col sm="4"  cols="12" v-for="(study, index) in not.ARRAY_F(first_staff_sister,number)" :key="index" class="px-1">
                                <v-card :to="'/about/sisters/'+study.key" flat="" color="" height="100%" hover=""  class="px-" outlined="">
                                    <v-hover v-slot:default="{hover}">
                                        <v-layout column fill-height> 
                                            <!-- //IMAGE -->
                                            <div> 
                                                <div v-if="!study.image">
                                                    <v-img
                                                        :src="not.noImg"
                                                        :lazy-src="not.imgLazy"
                                                        aspect-ratio="1.4"
                                                        class="grey lighten-2"/>  
                                                </div>
                                                <div v-else>
                                                    <v-img
                                                        :src="study.image.link"
                                                        :lazy-src="not.imgLazy"
                                                        aspect-ratio="1.4"
                                                        class="grey lighten-2"/>  
                                                </div>
                                            </div>
                                            <!-- //CONTENT -->
                                            <v-sheet   class="px-2 pb-">
                                                <div class="pt-1">
                                                    <div class="not-f6 font-weight-bold text-center">
                                                        <div v-if="not.size(study.name)<20">{{study.name}}</div>
                                                        <div v-else>{{study.name.substring(0,20)+"..."}}</div> 
                                                    </div> 
                                                </div>
                                                <div class="">
                                                    <div class="not-f4 font-weight-bold text-center font-italic primary--text">
                                                        <div v-if="not.size(study.apostolate)<20">{{study.apostolate}}</div>
                                                        <div v-else>{{study.apostolate.substring(0,20)+"..."}}</div> 
                                                    </div> 
                                                </div>
                                                <div class="pb-3">
                                                    <div class="not-f6 font-weight-bol text-center ">
                                                        <div v-if="not.size(study.congregation_name)<20">{{study.congregation_name}}</div>
                                                        <div v-else>{{study.congregation_name.substring(0,20)+"..."}}</div> 
                                                    </div> 
                                                </div> 
                                            </v-sheet> 
                                        </v-layout> 
                                    </v-hover> 
                                </v-card>
                            </v-col> 
                        </v-row> 
                    </v-col>
                    <v-btn large="" outlined="" color="white" to="/about/sisters">Our Sisters</v-btn>
                    
                </v-layout>
            </v-parallax> 
        </template>

        <v-parallax 
            height="450" 
            >
            <v-layout  justify-center=""  align-center="" column="" class="primary lighten-2 b1--text pb-5"> 
                <v-col sm="8">
                    <v-row>
                        <v-col sm="4"  cols="12" v-for="(community, index) in not.ARRAY_F(first_staff_sister,6)" :key="index" class="px-1">
                            <v-card 
                                :to="'communities/'+community.name" flat="" 
                                color="primary"  
                                width="" hover=""  class="mx-1" outlined="">
                                <v-hover v-slot:default="{hover}">
                                    <v-list>
                                        <v-list-item >
                                            <v-list-item-action>
                                                <v-icon>group</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>{{community.name}}</v-list-item-title>
                                                <v-list-item-subtitle>{{0}} sister(s)</v-list-item-subtitle> 
                                            </v-list-item-content> 
                                        </v-list-item>  
                                    </v-list> 
                                </v-hover> 
                            </v-card> 
                        </v-col> 
                    </v-row> 
                </v-col>
                <v-btn large="" outlined="" color="white" to="/about/communities">Our Communities</v-btn>
                
            </v-layout>
        </v-parallax>  

        <template> 
            <v-layout class="b2 pb-5">
                <v-container grid-list-xs>
                    <v-row class="text-center">  

                        <v-col sm="12">   
                            <div class="not-f8 font-weight-black py-5 primary--tex">
                                {{not.TEXT_UP('Religious Formation')}}
                            </div>
                            <div class="not-f7 font-italic">
                                <v-layout justify-center> 
                                    <div class="text-justify"> 
                                    <v-icon>mdi-format-quote-open</v-icon>
                                        Life is a journey consisting in various stages. The same is true of a commitment to give one's life to God. The formation period is of paramount importance.
                                    <v-icon>mdi-format-quote-close</v-icon>
                                    </div>
                                </v-layout>  
                            </div> 
                        </v-col>  
                    </v-row> 
                <br> 
                <v-layout justify-center="">
                    <v-btn to="/religious-formation" outlined="" color="primary">Read More</v-btn>
                </v-layout>
                </v-container> 
            </v-layout>
        </template>  
    </div>

    
</v-layout>
</template>

<script> 
    
   let pageName = 'Home'
    export default{
        name: pageName,
        props:['not'],  
        data: () => ({
            message: '',
            page_show: false,   
            page_current:1,
            page_size:10,
            images:[
                {src:'/images/teresian/t18.JPG',local:true},  
                {src:'/images/teresian/t10.JPG',local:true}, 
                {src:'/images/teresian/t4.JPG',local:true}, 
                {src:'/images/teresian/t8.JPG',local:true},  
                {src:'/images/teresian/t28.JPG',local:true}, 
                {src:'/images/teresian/t25.JPG',local:true}, 
            ] 
             
        }), 
        beforeCreate(){
             
        },
        created(){
             
        },
        mounted() {    
            this.not.NotHeaderNT({
                notShow:true,
                notType:"images",
                notImages:this.images,
                notText:true,
                notIndicators:true,
                notHeight:500
            })
            this.pageLoad(500)
        },
        computed:{
            number(){
                let n = 0
                name = this.not.vs.name
                if(name=="sm"){
                    n =2
                }else if (name=='xs') {
                    n = 1
                }else{
                    n=3
                }
                return n
            },
            us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            }, 
             
            services(){
                return this.$store.getters.getServices
            },
            sisters(){
                return this.$store.getters.getSisters
            }, 
            p_services(){
                if (!this.services) {
                    return null
                }
                let list = [...this.services]
                list.sort(this.not.dynamicSort("i",false)) 
                return this.not.pagination(list,this.page_current,this.number)
            },
            p_sisters(){
                if (!this.JOINED_sisters) {
                    return null
                }
                let list = [...this.JOINED_sisters]
                list.sort(this.not.dynamicSort("i",false)) 
                return this.not.pagination(list,this.page_current,this.number)
            },
            first_staff_sister(){
                let list = [...this.JOINED_sisters]
                list.sort(this.not.dynamicSort("staff",false)) 
                return list
            },
            JOINED_sisters(){
                let sisters = this.sisters 
                let joinSisters = this.not.JOIN_SISTERS(sisters)
                return joinSisters
            },
            communities(){
                let sisters = this.sisters 
                let communities = this.not.JOIN_COMMUNITIES(sisters) 

                //Search through  sisters
                return communities.filter(mm=>{
                    let name = this.not.TEXT_UP(mm.name) 
                    let nameSearch = this.not.TEXT_UP(this.nameSearch1)
                    let index = 1
                    if (nameSearch) {
                        index = name.indexOf(nameSearch)
                    }
                    return index != -1
                })
            },
        },
        //------------methods---------------
        methods: { 
          pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                    //CHECK 
                    if (ps) {
                        let getting = ps.find(process=>{
                            return process.name == 'getting/programs'
                        }) 

                        if (getting) {
                            this.page_show =false
                        }else{
                            this.page_show =true
                        } 
                    }else{
                        this.page_show =true
                    }
 
                },t)
            }
        }, 
        watch: {
            us(v){
                
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
    } 
    
</script>
 
